<template>
  <div>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
        <v-card>

          <div v-show="busy" class="text-xs-center" style="position:absolute; z-index:2; background-color:rgba(255,255,255,1); width:100%; height:100%;">
            <v-layout align-center justify-center row fill-height>
              <v-flex>
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <div>
                <h1 class="headline mt-4 mt-4" style="text-align:center;">Loading, please wait...</h1>
                </div>
              </v-flex>
            </v-layout>
          </div>

          <v-layout align-center justify-center row fill-height style="height:250px;">
            <v-flex style="text-align:center;">
                <v-icon v-html="'check_circle_outline'" style="color:green; font-size:70px;"></v-icon>
                <div style="font-size:20px; margin-top:10px;">Payment successful!</div>
            </v-flex>
          </v-layout>

        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'payment-success-view',
  data: () => ({
    busy: false,
    error: '',
    token: '',
    trip_name: '',
  }),
  computed: mapGetters({
    authenticated: 'authCheck'
  }),
  mounted() {
    this.busy = true
    this.token = this.$route.params.token

    axios.get(process.env.API_URL+'/payment_success/' + this.token)
    .then((response) => {
      this.trip_name = response.data.trip_name;
      this.busy = false
    })
    .catch((error) => {
      this.busy = false
    })
  },
  methods: {

  },
  metaInfo () {
    return { title: this.$t('home') }
  }
}
</script>



// WEBPACK FOOTER //
// pay_success.vue?73d520e8